// @flow

import qs from 'qs';
import Api from '../ApiBase';

const getListParams = () => qs.stringify({
  page: {
    limit: 100
  }
});

class DiplomasApi extends Api {
  fetch = async () => {
    const json = await this.request(`search_diplomas?${getListParams()}`);
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new DiplomasApi();
